<script setup lang="ts">
import { ref } from 'vue';
import { ArrowRight, UserFilled } from '@element-plus/icons-vue';
import type { ComponentSize, FormInstance, FormRules } from 'element-plus';
import  zhCn  from 'element-plus/es/locale/lang/zh-cn';

const locale = ref(zhCn);
const breadcrumb = useBreadcrumbStore();
const { links } = storeToRefs(breadcrumb);
const cookie = useCookie("accessToken");
const user = useUserStore();
const { userInfo } = storeToRefs(user);
const menuStore = useMenuStore();
const { active } = storeToRefs(menuStore);
const isCollapse = ref(false)
const collapseClasee = computed(() => isCollapse.value ? "hamburger is-active" : "hamburger");
const handleOpen = (key: string, keyPath: string[]) => {
  console.log(key, keyPath)
}
const handleClose = (key: string, keyPath: string[]) => {
  console.log(key, keyPath)
}
const handleSelect = () => {
  asideWidth.value = null;
}
const tabStore = useTagStore();
const { removeTab, clickTab } = tabStore;
const { editableTabs, editableTabsValue } = storeToRefs(tabStore);
// 窗口高度
const { width } = useWindowSize();
const asideWidth = ref<string | null>(null);
const collapseClick = () => {
  if (width.value <= 768) {
    asideWidth.value = '210px';
    isCollapse.value = false;
  } else {
    isCollapse.value = !isCollapse.value;
    asideWidth.value = 'auto';
  }
}
watchEffect(() => {
  if (width.value <= 768) {
    asideWidth.value = null;
  } else {
    
  }
});
const logOut = async () => {
  ElMessageBox.confirm(
    '您确认注销登出吗?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
  .then(async () => {
    cookie.value = null;
    await navigateTo('/login', { redirectCode: 301 });
  })
  .catch(() => {
    ElMessage({
      type: 'info',
      message: '已取消登出',
    })
  })
}
const ruleFormRef = ref<FormInstance>();
const isPassword = ref(false);
const changePassword = () => {
  isPassword.value = true;
}
interface RuleForm {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}
const ruleForm = reactive<RuleForm>({
  oldPassword: "",
  newPassword: "",
  confirmPassword: "",
});
// const validatePass = (rule: any, value: any, callback: any) => {
//   if (value === '') {
//     callback(new Error('请输入密码'));
//   } else {
//     if (ruleForm.confirmPassword !== '') {
//       if (!ruleFormRef.value) return;
//       ruleFormRef.value.validateField('confirmPassword');
//     }
//     callback();
//   }
// }
const validatePass2 = (rule: any, value: any, callback: any) => {
  // if (value === '') {
  //   callback(new Error('请重新输入密码'));
  // } else 
  if (value !== ruleForm.newPassword) {
    callback(new Error("两次输入不匹配！"));
  } else {
    callback();
  }
}
const rules = reactive<FormRules<RuleForm>>({
  oldPassword: [
    { required: true, message: '请输入旧密码', trigger: 'blur' }
  ],
  newPassword: [
    { required: true, message: '请输入新密码', trigger: 'blur' }
    // { validator: validatePass, trigger: 'blur' },
  ],
  confirmPassword: [
    { required: true, message: '请再次输入新密码', trigger: 'blur' },
    { validator: validatePass2, trigger: 'blur' },
  ]
})
const formSize = ref<ComponentSize>('default');
const submitForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return
  formEl.validate(async (valid) => {
    if (valid) {
      const data = await passwordFetch({
        method:'POST',
        body: ruleForm,
        server:false,
        key:'loginFetch'
      })
      isPassword.value = false;
      if (data.code == 0) {
        ElMessage({
          type: 'success',
          message: '修改成功',
        })
        formEl.resetFields();
      } else { 
        ElMessage({
          type: 'error',
          message: '修改失败',
        })
      }
    } else {
      ElMessage({
        type: 'error',
        message: '提交失败',
      })
    }
  })
  // formEl.resetFields();
};

let activeUser = await userFetch({ method: 'get' });
userInfo.value = activeUser.data;
</script>

<template>
  <el-container>
    <div 
      v-if="width <= 768 && asideWidth != null" 
      @click="asideWidth = null"
    />
    <el-aside :style="{ width: asideWidth }">
      <div class="logo_area">
        <img src="/assets/toyo.png" style="width: 25px; height: 25px;"/>
        <h3 v-if="!isCollapse">东洋通信</h3>
      </div>
      <el-scrollbar>
        <!-- <ClientOnly> -->
          <el-menu
            active-text-color="#4080ff"
            background-color="#304156"
            class="el-menu-vertical-demo"
            :default-active="active"
            text-color="#bfcdd9"
            :collapse="isCollapse"
            @open="handleOpen"
            @close="handleClose"
            @select="handleSelect"
          >
            <el-menu-item index="/home">
              <SvgIcon icon-class="homepage" style="margin-right: 5px;"/>
              <template #title>
                <NuxtLinkLocale to="/home" style="width: 100%;">
                  <span>首页</span>
                </NuxtLinkLocale>
              </template>
            </el-menu-item>
            <el-sub-menu index="2" v-if="userInfo?.type == 'A'">
              <template #title>
                <SvgIcon icon-class="demand" style="margin-right: 5px;"/>
                <span>询价管理</span>
              </template>
              <el-menu-item index="/demand/requisition" v-if="userInfo?.type == 'A'">
                <NuxtLinkLocale to="/demand/requisition" style="width: 100%;">
                  <SvgIcon icon-class="request" style="margin-right: 5px;"/>
                  <span>需求申请单</span>
                </NuxtLinkLocale>
              </el-menu-item>
              <el-menu-item index="/demand/progress" v-if="userInfo?.type == 'A'">
                <NuxtLinkLocale to="/demand/progress" style="width: 100%;">
                  <SvgIcon icon-class="request" style="margin-right: 5px;"/>
                  <span>进度查询</span>
                </NuxtLinkLocale>
              </el-menu-item>
            </el-sub-menu>
            <el-sub-menu index="3" v-if="userInfo?.type == 'B'">
              <template #title>
                <SvgIcon icon-class="inquiry" style="margin-right: 5px;"/>
                <span>报价管理</span>
              </template>
              <el-menu-item index="/inquiry/list" v-if="userInfo?.type == 'B'">
                <NuxtLinkLocale to="/inquiry/list" style="width: 100%;">
                  <SvgIcon icon-class="list" style="margin-right: 5px;"/>
                  <span>询价单列表</span>
                </NuxtLinkLocale>
              </el-menu-item>
            </el-sub-menu>
          </el-menu>
        <!-- </ClientOnly> -->
      </el-scrollbar>
    </el-aside>
    <el-container>
      <el-header>
        <div class="fixed-header">
          <div class="navbar-container">
            <div class="left">
              <svg-icon 
                icon-class="collapse" 
                :class="collapseClasee" 
                size="1.2em"
                @click="collapseClick"
              />
              <el-breadcrumb :separator-icon="ArrowRight">
                <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
                <el-breadcrumb-item v-for="item in links">
                  <NuxtLinkLocale :to="item.link">{{ item.name }}</NuxtLinkLocale>
                </el-breadcrumb-item>
                <!-- <el-breadcrumb-item>用户管理</el-breadcrumb-item> -->
              </el-breadcrumb>
            </div>
            <div class="right">
              <el-dropdown>
                <div class="userIcon">
                  <el-icon size="16px"><UserFilled /></el-icon>
                  <p>{{ userInfo?.username }}</p>
                </div>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item @click="changePassword">更改密码</el-dropdown-item>
                    <el-dropdown-item @click="logOut">注销登出</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </div>
          <div class="tags-container">
            <el-tabs
              v-model="editableTabsValue"
              type="border-card"
              class="demo-tabs"
              @tab-remove="removeTab"
              @tab-click="clickTab"
            >
              <el-tab-pane
                v-for="item in editableTabs"
                :key="item.name"
                :label="item.title"
                :name="item.name"
                :closable="item.disabled"
              />
            </el-tabs>
          </div>
        </div>
      </el-header>
      <el-main>
        <el-config-provider :locale="locale">
          <slot />
        </el-config-provider>
        
      </el-main>
    </el-container>
    <el-dialog
      v-model="isPassword"
      title="修改密码"
      width="380"
      align-center
      destroy-on-close
    >
      <el-form
        ref="ruleFormRef"
        style="max-width: 600px"
        :model="ruleForm"
        :rules="rules"
        label-width="auto"
        class="demo-ruleForm"
        :size="formSize"
        status-icon
      >
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input type="password" show-password v-model="ruleForm.oldPassword" />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input type="password" show-password v-model="ruleForm.newPassword" />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input type="password" show-password v-model="ruleForm.confirmPassword" />
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="isPassword = false">取消</el-button>
          <el-button type="primary" @click="submitForm(ruleFormRef)">确定</el-button>
        </div>
      </template>
    </el-dialog>
  </el-container>
</template>

<style lang="scss" scope>
.el-aside {
  overflow: hidden!important;
  width: auto;
  @media (width <= 768px) {
    width: 0;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    background-color: var(--menu-background);
    transition: width .28s;
  }
}
.el-tabs {
  & > .el-tabs__header {
    height: auto;
  }
}
.el-header {
  padding: 0;
  --el-header-height: 90px;
}
.el-main {
  background-color: #f5f8fd;
}
.fixed-header {
  .navbar-container {
    display: flex;
    justify-content: space-between;
    .left {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 50px;
    }
    .right {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 50px;
      .el-dropdown {
        height: 100%;
        .userIcon {
          display: flex;
          align-items: center;
          margin: 0 25px 0 25px;
          p {
            margin-left: 5px;
          }
        }
        
      }
      &:hover {
        background: rgba(0, 0, 0, 0.1);
      }
    }
  }
}
.hamburger {
  vertical-align: middle;
  cursor: pointer;
  transform: scaleX(-1);
  padding: 0 15px 0 15px;
  color: #606266;
  box-sizing: content-box;
}
.is-active {
  transform: scaleX(1);
}
.el-menu {
  border-right: solid 1px #304156!important;
  height: 100%;
}
.logo_area {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #2d3748;
  height: 50px;
  width: auto;
  h3 {
    color: white;
    font-family: STKaiti;
    font-weight: 300;
    margin-left: 5px;
  }
}
.el-container {
  height: 100vh;
  width: 100vw;
}
.el-dialog {
  @media (width <= 768px) {
    --el-dialog-width: 95%!important;
  }
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 210px;
  min-height: 100%;
}
.el-scrollbar__view {
  height: calc(100% - 50px);
}
</style>